module.exports = __webpack_public_path__ + "img/elementwidths_jasp.54a27bdd.png";